import { useEffect, useState } from "react";
import "./index.css";
import { FaRegEdit } from "react-icons/fa";
import { useParent } from "../../../../../APIContext/ParentContext";
import EditProfileModal from "../../../../../Components/EditProfileModal/EditProfileModal";
const ProfileDetail = () => {
  const { parentProfile, fetchCurrentParent } = useParent();

  const [data, setData] = useState({});
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchCurrentParent();
  }, [showModal]);

  useEffect(() => {
    if (parentProfile) {
      setData(parentProfile);
    }
  }, [parentProfile]);

  if (!data) return <p>Loading...</p>;
  return (
    <>
      <div
        style={{ filter: "brightness(1.28)" }}
        className="profile-content-area bg-custom"
      >
        <div className="profile-detail-container">
          <h2 className="profile-title text-clip">Your Profile Details</h2>
          <div className="profile-card bg-custom brightness">
            <div className="profile-card-header">
              <h3 className="text-clip">Your Personal Information</h3>
              <button className="edit-btn" onClick={() => setShowModal(true)}>
                <span className="brightness">
                  Edit Details
                  <FaRegEdit
                    style={{ fontSize: "20px", paddingBottom: "4px" }}
                  />
                </span>
              </button>
            </div>

            <div className="profile-row">
              <div className="profile-field">
                <p className="label text-clip">First Name</p>
                <span className="value text-clip">
                  {data.user?.first_name || "-"}
                </span>
              </div>
              <div className="profile-field">
                <p className="label text-clip">Last Name</p>
                <span className="value text-clip">
                  {data.user?.last_name || "-"}
                </span>
              </div>
            </div>

            <div className="profile-row">
              <div className="profile-field">
                <p className="label text-clip">User Name</p>
                <span className="value text-clip">
                  {data.user?.username || "-"}
                </span>
              </div>
              <div className="profile-field">
                <p className="label text-clip">Email Address</p>
                <span className="value text-clip">
                  {data.user?.email || "-"}
                </span>
              </div>
            </div>

            <div className="profile-row">
              <div className="profile-field">
                <p className="label text-clip">Phone Number</p>
                <span className="value text-clip">{data?.phone || "-"}</span>
              </div>
              <div className="profile-field">
                <p className="label text-clip">Home Address</p>
                <span className="value text-clip">{data?.address || "-"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <EditProfileModal data={data} onClose={() => setShowModal(false)} />
      )}
    </>
  );
};

export default ProfileDetail;
